<template>
  <main-template>
    <abstract-submission-receipt
              class="self"
              :header="'termsAndConditions.reviewSubmission.header'"
              :reason="'termsAndConditions.reviewSubmission.dataError.reason'"
              :title="'termsAndConditions.reviewSubmission.dataError.title'">
          <div @click="handleReturnToFnol">{{ $t('termsAndConditions.reviewSubmission.dataError.highLight') }}</div>
    </abstract-submission-receipt>
  </main-template>
</template>

<script lang="ts" setup>
    import AbstractSubmissionReceipt from '@/components/reviewSubmission/AbstractSubmissionReceipt.vue'
    import router from '@/router'
    import { useRoute } from 'vue-router'
    import MainTemplate from '@/components/MainTemplate.vue'

    const route = useRoute()
    const handleReturnToFnol = () => {
      router.push({ name: 'FNOL Review and Submission', params: { visible: 'true' }, query: { data: route.query.data } })
    }
</script>

<style scoped>
.self  {
  margin:auto
}
</style>
